/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnections from './receive-connection-types';

export default  () => (dispatch) => {
    
    dispatch({
        type: actions.CONNECTION_TYPES_REQUEST,
    });

    return cecSdk
        .connectionType()
        .listAll()
        .then((connectionTypes) => {
            dispatch({
                type: actions.CONNECTION_TYPES_REQUEST_SUCCESS,
            });
            dispatch(receiveConnections(connectionTypes));
            return connectionTypes;
        });
};